import request from "@/utils/request";
// 数据资讯
export function getArticleApi(params) {
    return request({
        url: "/get_article",
        method: "get",
        headers: { secret: false },
        params,
    });
}
// 数据报告
export function getArticlelistApi(params) {
    return request({
        url: "/get_article_list",
        method: "get",
        headers: { secret: false },
        params,
    });
}
// 数据报告浏览量
export function getarticleviewApi(params) {
    return request({
        url: "/add_article_view",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 配置
export function getConfigApi(params) {
    return request({
        url: "/get_config",
        method: "get",
        headers: { secret: false },
        params,
    });
}
// 文章列表
export function getArticleAadminapi(params) {
    return request({
        url: "/article",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 文章列表添加
export function addArticleAadminapi(data) {
    return request({
        url: "/article",
        method: "post",
        headers: { secret: true },
        data,
    });
}
// 文章列表编辑
export function editArticleAadminapi(data) {
    return request({
        url: `/article/${data.id}`,
        method: "put",
        headers: { secret: true },
        data,
    });
}
// 文章列表删除
export function deleteArticleAadminapi(data) {
    return request({
        url: `/article/${data.id}`,
        method: "delete",
        headers: { secret: true },
    });
}
// 文章分类
export function getArticle_categoryAadminapi(params) {
    return request({
        url: "/article_category",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 系统公告
export function getNoticelistapi(params) {
    return request({
        url: "/get_notice_list",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 系统公告消息推送
export function getNoticecountapi(params) {
    return request({
        url: "/get_notice_count",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 阅读系统公告
export function readNoticeapi(data) {
    return request({
        url: "/add_notice_relevance",
        method: "post",
        headers: { secret: true },
        data,
    });
}
// 获取省市区
export function getCityApi(params) {
    return request({
        url: "/transfer/get_location",
        method: "get",
        headers: { secret: false },
        params,
    });
}
